export default __webpack_public_path__ + "static/media/geneva.694c4429.jpg";